/**
 * ランクI
 */
export const TBOX_ITEM_MEDICINAL_HERB = 'やくそう'
export const TBOX_ITEM_EVAC_U_BELL = 'おもいでのすず'
export const TBOX_ITEM_MAGIC_WATER = 'まほうのせいすい'
export const TBOX_ITEM_HOLY_WATER = 'せいすい'
export const TBOX_ITEM_GLEEBAN_GROAT = 'グビアナどうか'
export const TBOX_ITEM_ANTIDOTAL_HERB = 'どくけしそう'
export const TBOX_ITEM_OAKEN_CLUB = 'こんぼう'
export const TBOX_ITEM_MOONWORT_BULB = 'まんげつそう'
export const TBOX_ITEM_CHIMAERA_WING = 'キメラのつばさ'
export const TBOX_ITEM_125G = '125G'
export const TBOX_ITEM_POP_SOCKS = 'ニーソックス'
export const TBOX_ITEM_STRONG_MEDICINE = '上やくそう'
export const TBOX_ITEM_SILVER_BRACELETS = 'ぎんのリスト'
export const TBOX_ITEM_BUNNY_TAIL = 'うさぎのおまもり'

export const TBOX_RANK_I_PROBABILITIES = [
  { probability: 10, name: TBOX_ITEM_MEDICINAL_HERB },
  { probability: 10, name: TBOX_ITEM_EVAC_U_BELL },
  { probability: 5, name: TBOX_ITEM_MAGIC_WATER },
  { probability: 10, name: TBOX_ITEM_HOLY_WATER },
  { probability: 10, name: TBOX_ITEM_GLEEBAN_GROAT },
  { probability: 8, name: TBOX_ITEM_ANTIDOTAL_HERB },
  { probability: 5, name: TBOX_ITEM_OAKEN_CLUB },
  { probability: 8, name: TBOX_ITEM_MOONWORT_BULB },
  { probability: 10, name: TBOX_ITEM_CHIMAERA_WING },
  { probability: 10, name: TBOX_ITEM_125G },
  { probability: 2, name: TBOX_ITEM_POP_SOCKS },
  { probability: 8, name: TBOX_ITEM_STRONG_MEDICINE },
  { probability: 2, name: TBOX_ITEM_SILVER_BRACELETS },
  { probability: 2, name: TBOX_ITEM_BUNNY_TAIL }
]

/**
 * ランクH
 */
export const TBOX_ITEM_ROYAL_SOIL = 'まりょくの土'
export const TBOX_ITEM_LAVA_LUMP = 'ようがんのカケラ'
export const TBOX_ITEM_ANGEL_BELL = '天使のすず'
export const TBOX_ITEM_SILVER_PLATTER = 'シルバートレイ'
export const TBOX_ITEM_FISTICUP = 'げんこつダケ'
export const TBOX_ITEM_SUPERIOR_MEDICINE = 'いやしそう'
export const TBOX_ITEM_STRONG_ANTIDOTE = '上どくけしそう'
export const TBOX_ITEM_268G = '268G'
//export const TBOX_ITEM_GLEEBAN_GROAT = 'グビアナどうか'
export const TBOX_ITEM_ROCKBOMB_SHARD = 'ばくだん石'
export const TBOX_ITEM_IRON_NAIL = 'てつのクギ'
export const TBOX_ITEM_GOLD_RING = 'きんのゆびわ'
export const TBOX_ITEM_GOLD_BRACER = 'きんのブレスレット'
export const TBOX_ITEM_IRON_MASK = 'てっかめん'

export const TBOX_RANK_H_PROBABILITIES = [
  { probability: 8, name: TBOX_ITEM_ROYAL_SOIL },
  { probability: 8, name: TBOX_ITEM_LAVA_LUMP },
  { probability: 10, name: TBOX_ITEM_ANGEL_BELL },
  { probability: 2, name: TBOX_ITEM_SILVER_PLATTER },
  { probability: 10, name: TBOX_ITEM_FISTICUP },
  { probability: 10, name: TBOX_ITEM_SUPERIOR_MEDICINE },
  { probability: 10, name: TBOX_ITEM_STRONG_ANTIDOTE },
  { probability: 10, name: TBOX_ITEM_268G },
  { probability: 8, name: TBOX_ITEM_GLEEBAN_GROAT },
  { probability: 8, name: TBOX_ITEM_ROCKBOMB_SHARD },
  { probability: 10, name: TBOX_ITEM_IRON_NAIL },
  { probability: 2, name: TBOX_ITEM_GOLD_RING },
  { probability: 2, name: TBOX_ITEM_GOLD_BRACER },
  { probability: 2, name: TBOX_ITEM_IRON_MASK }
]

/**
 * ランクG
 */
export const TBOX_ITEM_CANNIBOX = 'ひとくいばこ'
export const TBOX_ITEM_TOAD_OIL = 'ガマのあぶら'
export const TBOX_ITEM_MINI_MEDAL = 'ちいさなメダル'
//export const TBOX_ITEM_FISTICUP = 'げんこつダケ'
//export const TBOX_ITEM_GLEEBAN_GROAT = 'グビアナどうか'
export const TBOX_ITEM_450G = '450G'
export const TBOX_ITEM_IRON_ORE = 'てっこうせき'
export const TBOX_ITEM_SLIME_SHIELD = 'スライムトレイ'
export const TBOX_ITEM_CORUNDUM = 'ルビーのげんせき'
export const TBOX_ITEM_RESURROCK = '命の石'
export const TBOX_ITEM_GLEEBAN_GUINEA = 'グビアナぎんか'
export const TBOX_ITEM_STRENGTH_RING = 'ちからのゆびわ'
export const TBOX_ITEM_AGILITY_RING = 'はやてのリング'

export const TBOX_RANK_G_PROBABILITIES = [
  { probability: 10, name: TBOX_ITEM_CANNIBOX },
  { probability: 10, name: TBOX_ITEM_TOAD_OIL },
  { probability: 10, name: TBOX_ITEM_MINI_MEDAL },
  { probability: 10, name: TBOX_ITEM_FISTICUP },
  { probability: 10, name: TBOX_ITEM_GLEEBAN_GROAT },
  { probability: 10, name: TBOX_ITEM_450G },
  { probability: 10, name: TBOX_ITEM_IRON_ORE },
  { probability: 1, name: TBOX_ITEM_SLIME_SHIELD },
  { probability: 10, name: TBOX_ITEM_CORUNDUM },
  { probability: 10, name: TBOX_ITEM_RESURROCK },
  { probability: 5, name: TBOX_ITEM_GLEEBAN_GUINEA },
  { probability: 2, name: TBOX_ITEM_STRENGTH_RING },
  { probability: 2, name: TBOX_ITEM_AGILITY_RING }
]

/**
 * ランクF
 */
export const TBOX_ITEM_MIMIC = 'ミミック'
export const TBOX_ITEM_MANKY_MUD = 'どくどくヘドロ'
export const TBOX_ITEM_NECTAR = '花のみつ'
//export const TBOX_ITEM_MINI_MEDAL = 'ちいさなメダル'
//export const TBOX_ITEM_GLEEBAN_GUINEA = 'グビアナぎんか'
//export const TBOX_ITEM_MAGIC_WATER = 'まほうのせいすい'
export const TBOX_ITEM_670G = '670G'
export const TBOX_ITEM_SORCERERS_STONE = 'ひらめきのジュエル'
export const TBOX_ITEM_FLINTSTONE = 'つけもの石'
export const TBOX_ITEM_MIRRORSTONE = 'かがみ石'
export const TBOX_ITEM_FUDDLE_BOW = 'ゆうわくの弓'
export const TBOX_ITEM_GLOMBOLERO = 'ふしぎなボレロ'
export const TBOX_ITEM_SAINTS_ASHES = 'せいじゃのはい'
export const TBOX_ITEM_MALICITE = 'うらみのほうじゅ'

export const TBOX_RANK_F_PROBABILITIES = [
  { probability: 5, name: TBOX_ITEM_MIMIC },
  { probability: 15, name: TBOX_ITEM_MANKY_MUD },
  { probability: 15, name: TBOX_ITEM_NECTAR },
  { probability: 12, name: TBOX_ITEM_MINI_MEDAL },
  { probability: 10, name: TBOX_ITEM_GLEEBAN_GUINEA },
  { probability: 15, name: TBOX_ITEM_MAGIC_WATER },
  { probability: 12, name: TBOX_ITEM_670G },
  { probability: 2, name: TBOX_ITEM_SORCERERS_STONE },
  { probability: 5, name: TBOX_ITEM_FLINTSTONE },
  { probability: 5, name: TBOX_ITEM_MIRRORSTONE },
  { probability: 1, name: TBOX_ITEM_FUDDLE_BOW },
  { probability: 1, name: TBOX_ITEM_GLOMBOLERO },
  { probability: 1, name: TBOX_ITEM_SAINTS_ASHES },
  { probability: 1, name: TBOX_ITEM_MALICITE }
]

/**
 * ランクE
 */
//export const TBOX_ITEM_MIMIC ='ミミック'
export const TBOX_ITEM_PANACEA = 'ばんのうぐすり'
export const TBOX_ITEM_HEPHAESTUS_FLAME = 'ヘパイトスのひだね'
//export const TBOX_ITEM_MAGIC_WATER = 'まほうのせいすい'
export const TBOX_ITEM_MUSCLE_BELT = 'あらくれベルト'
export const TBOX_ITEM_MAID_OUTFIT = 'メイド服'
export const TBOX_ITEM_THUG_BOOTS = 'あらくれブーツ'
export const TBOX_ITEM_THUGS_MUG = 'あらくれマスク'
export const TBOX_ITEM_MAIDS_MOP = 'ヘッドドレス'
export const TBOX_ITEM_TOUGHIE_TROUSERS = 'あらくれズボン'
export const TBOX_ITEM_FINESSENCE = 'ぶどうエキス'
export const TBOX_ITEM_AGGRESSENCE = 'とうこんエキス'
export const TBOX_ITEM_DANGEROUS_BUSTIER = 'あぶないビスチェ'
//export const TBOX_ITEM_MINI_MEDAL = 'ちいさなメダル'
export const TBOX_ITEM_BROUHAHA_BOOMSTICK = 'まてきの杖'
export const TBOX_ITEM_NARSPICIOUS = 'あやかしそう'

export const TBOX_RANK_E_PROBABILITIES = [
  { probability: 5, name: TBOX_ITEM_MIMIC },
  { probability: 15, name: TBOX_ITEM_PANACEA },
  { probability: 10, name: TBOX_ITEM_HEPHAESTUS_FLAME },
  { probability: 15, name: TBOX_ITEM_MAGIC_WATER },
  { probability: 1, name: TBOX_ITEM_MUSCLE_BELT },
  { probability: 1, name: TBOX_ITEM_MAID_OUTFIT },
  { probability: 1, name: TBOX_ITEM_THUG_BOOTS },
  { probability: 1, name: TBOX_ITEM_THUGS_MUG },
  { probability: 1, name: TBOX_ITEM_MAIDS_MOP },
  { probability: 1, name: TBOX_ITEM_TOUGHIE_TROUSERS },
  { probability: 10, name: TBOX_ITEM_FINESSENCE },
  { probability: 10, name: TBOX_ITEM_AGGRESSENCE },
  { probability: 1, name: TBOX_ITEM_DANGEROUS_BUSTIER },
  { probability: 12, name: TBOX_ITEM_MINI_MEDAL },
  { probability: 1, name: TBOX_ITEM_BROUHAHA_BOOMSTICK },
  { probability: 15, name: TBOX_ITEM_NARSPICIOUS }
]

/**
 * ランクD
 */
//export const TBOX_ITEM_MIMIC ='ミミック'
export const TBOX_ITEM_MYSTIFYING_MIXTURE = 'おかしなくすり'
//export const TBOX_ITEM_HEPHAESTUS_FLAME = 'ヘパイトスのひだね'
//export const TBOX_ITEM_GLEEBAN_GUINEA = 'グビアナぎんか'
export const TBOX_ITEM_ASTRAL_PLUME = '天使のはね'
export const TBOX_ITEM_DENSINIUM = 'ヘビーメタル'
export const TBOX_ITEM_RIOTOUS_WRISTBANDS = 'ぶしんのリスト'
export const TBOX_ITEM_FINGERLESS_GLOVES = 'オープンフィンガー'
export const TBOX_ITEM_MYTHRIL_ORE = 'ミスリルこうせき'
export const TBOX_ITEM_VETERANS_GLOVES = '古強者のグローブ'
//export const TBOX_ITEM_MINI_MEDAL = 'ちいさなメダル'
export const TBOX_ITEM_OH_NO_BOW = 'じごくの弓'
export const TBOX_ITEM_BLESSED_BOOTS = 'しんかんのブーツ'
export const TBOX_ITEM_SKULL_RING = 'ドクロのゆびわ'
export const TBOX_ITEM_HELAS_HAMMER = 'まじんのかなづち'
export const TBOX_ITEM_HADES_HELM = 'サタンヘルム'
export const TBOX_ITEM_DEMON_WHIP = 'あくまのムチ'

export const TBOX_RANK_D_PROBABILITIES = [
  { probability: 10, name: TBOX_ITEM_MIMIC },
  { probability: 15, name: TBOX_ITEM_MYSTIFYING_MIXTURE },
  { probability: 15, name: TBOX_ITEM_HEPHAESTUS_FLAME },
  { probability: 15, name: TBOX_ITEM_GLEEBAN_GUINEA },
  { probability: 10, name: TBOX_ITEM_ASTRAL_PLUME },
  { probability: 6, name: TBOX_ITEM_DENSINIUM },
  { probability: 1, name: TBOX_ITEM_RIOTOUS_WRISTBANDS },
  { probability: 1, name: TBOX_ITEM_FINGERLESS_GLOVES },
  { probability: 10, name: TBOX_ITEM_MYTHRIL_ORE },
  { probability: 1, name: TBOX_ITEM_VETERANS_GLOVES },
  { probability: 10, name: TBOX_ITEM_MINI_MEDAL },
  { probability: 1, name: TBOX_ITEM_OH_NO_BOW },
  { probability: 1, name: TBOX_ITEM_BLESSED_BOOTS },
  { probability: 1, name: TBOX_ITEM_SKULL_RING },
  { probability: 1, name: TBOX_ITEM_HELAS_HAMMER },
  { probability: 1, name: TBOX_ITEM_HADES_HELM },
  { probability: 1, name: TBOX_ITEM_DEMON_WHIP }
]

/**
 * ランクC
 */
//export const TBOX_ITEM_MIMIC ='ミミック'
//export const TBOX_ITEM_SAINTS_ASHES = 'せいじゃのはい'
//export const TBOX_ITEM_DENSINIUM = 'ヘビーメタル'
export const TBOX_ITEM_LUCIDA_SHARD = 'ほしのカケラ'
export const TBOX_ITEM_SAGES_ELIXIR = 'けんじゃのせいすい'
export const TBOX_ITEM_880G = '880G'
export const TBOX_ITEM_PERFECT_PANACEA = '超ばんのうぐすり'
export const TBOX_ITEM_DEPRESSING_SHOES = 'しわよせのくつ'
export const TBOX_ITEM_UNHAPPY_HAT = 'しわよせのぼうし'
//export const TBOX_ITEM_MINI_MEDAL = 'ちいさなメダル'
export const TBOX_ITEM_VETERANS_ARMOUR = '古強者のよろい'
export const TBOX_ITEM_SPELLSPADRILLES = 'だいまどうシューズ'
export const TBOX_ITEM_VETERANS_BOOTS = '古強者のブーツ'
export const TBOX_ITEM_COMBAT_BOOTS = 'ぶしんのブーツ'
export const TBOX_ITEM_SHE_MAGE_SHOES = 'まじょのブーツ'
export const TBOX_ITEM_TRINITY_TIGHTS = 'しんかんのタイツ'
export const TBOX_ITEM_RUINOUS_SHIELD = 'はめつの盾'
export const TBOX_ITEM_DIVINE_DRESS = 'さとりのワンピース'
export const TBOX_ITEM_SKULL_HELM = 'ドクロのかぶと'
export const TBOX_ITEM_MATADORS_GLOVES = 'マタドールグラブ'

export const TBOX_RANK_C_PROBABILITIES = [
  { probability: 10, name: TBOX_ITEM_MIMIC },
  { probability: 10, name: TBOX_ITEM_SAINTS_ASHES },
  { probability: 10, name: TBOX_ITEM_DENSINIUM },
  { probability: 10, name: TBOX_ITEM_LUCIDA_SHARD },
  { probability: 10, name: TBOX_ITEM_SAGES_ELIXIR },
  { probability: 15, name: TBOX_ITEM_880G },
  { probability: 6, name: TBOX_ITEM_PERFECT_PANACEA },
  { probability: 2, name: TBOX_ITEM_DEPRESSING_SHOES },
  { probability: 2, name: TBOX_ITEM_UNHAPPY_HAT },
  { probability: 15, name: TBOX_ITEM_MINI_MEDAL },
  { probability: 1, name: TBOX_ITEM_VETERANS_ARMOUR },
  { probability: 1, name: TBOX_ITEM_SPELLSPADRILLES },
  { probability: 1, name: TBOX_ITEM_VETERANS_BOOTS },
  { probability: 1, name: TBOX_ITEM_COMBAT_BOOTS },
  { probability: 1, name: TBOX_ITEM_SHE_MAGE_SHOES },
  { probability: 1, name: TBOX_ITEM_TRINITY_TIGHTS },
  { probability: 1, name: TBOX_ITEM_RUINOUS_SHIELD },
  { probability: 1, name: TBOX_ITEM_DIVINE_DRESS },
  { probability: 1, name: TBOX_ITEM_SKULL_HELM },
  { probability: 1, name: TBOX_ITEM_MATADORS_GLOVES }
]

/**
 * ランクB
 */
export const TBOX_ITEM_PANDORAS_BOX = 'パンドラボックス'
export const TBOX_ITEM_ENCHANTED_STONE = 'せいれいせき'
//export const TBOX_ITEM_MYTHRIL_ORE = 'ミスリルこうせき'
//export const TBOX_ITEM_SAGES_ELIXIR = 'けんじゃのせいすい'
export const TBOX_ITEM_1500G = '1500G'
//export const TBOX_ITEM_MINI_MEDAL = 'ちいさなメダル'
export const TBOX_ITEM_GLEEBAN_GOLD_PIECE = 'グビアナきんか'
export const TBOX_ITEM_GOLD_BAR = 'きんかい'
export const TBOX_ITEM_HERO_SPEAR = 'えいゆうのやり'
export const TBOX_ITEM_PRUNING_KNIFE = 'こがらしのダガー'
export const TBOX_ITEM_WYRMWAND = 'ドラゴンの杖'
export const TBOX_ITEM_WIZARDLY_WHIP = 'カルベロビュート'
export const TBOX_ITEM_BEAST_CLAWS = 'まじゅうのツメ'
export const TBOX_ITEM_ATTRIBEAUTY = '風林火山'
export const TBOX_ITEM_HEAVY_HATCHET = 'ふんさいのおおなた'
export const TBOX_ITEM_MEGATON_HAMMER = 'メガトンハンマー'
export const TBOX_ITEM_PENTARANG = 'ペンタグラム'

export const TBOX_RANK_B_PROBABILITIES = [
  { probability: 5, name: TBOX_ITEM_PANDORAS_BOX },
  { probability: 13, name: TBOX_ITEM_ENCHANTED_STONE },
  { probability: 13, name: TBOX_ITEM_MYTHRIL_ORE },
  { probability: 10, name: TBOX_ITEM_SAGES_ELIXIR },
  { probability: 15, name: TBOX_ITEM_1500G },
  { probability: 15, name: TBOX_ITEM_MINI_MEDAL },
  { probability: 15, name: TBOX_ITEM_GLEEBAN_GOLD_PIECE },
  { probability: 5, name: TBOX_ITEM_GOLD_BAR },
  { probability: 1, name: TBOX_ITEM_HERO_SPEAR },
  { probability: 1, name: TBOX_ITEM_PRUNING_KNIFE },
  { probability: 1, name: TBOX_ITEM_WYRMWAND },
  { probability: 1, name: TBOX_ITEM_WIZARDLY_WHIP },
  { probability: 1, name: TBOX_ITEM_BEAST_CLAWS },
  { probability: 1, name: TBOX_ITEM_ATTRIBEAUTY },
  { probability: 1, name: TBOX_ITEM_HEAVY_HATCHET },
  { probability: 1, name: TBOX_ITEM_MEGATON_HAMMER },
  { probability: 1, name: TBOX_ITEM_PENTARANG }
]

/**
 * ランクA
 */
//export const TBOX_ITEM_PANDORAS_BOX = 'パンドラボックス'
//export const TBOX_ITEM_ASTRAL_PLUME = '天使のはね'
export const TBOX_ITEM_ETHEREAL_STONE = 'げんませき'
export const TBOX_ITEM_3000G = '3000G'
//export const TBOX_ITEM_SAGES_ELIXIR = 'けんじゃのせいすい'
//export const TBOX_ITEM_MINI_MEDAL = 'ちいさなメダル'
//export const TBOX_ITEM_GLEEBAN_GOLD_PIECE = 'グビアナきんか'
export const TBOX_ITEM_RECKLESS_NECKLACE = 'しにがみの首かざり'
export const TBOX_ITEM_ORICHALCUM = 'オリハルコン'
export const TBOX_ITEM_METAL_SLIME_SWORD = 'メタスラの剣'
export const TBOX_ITEM_METAL_SLIME_SPEAR = 'メタスラのやり'
export const TBOX_ITEM_METAL_SLIME_SHIELD = 'メタスラの盾'
export const TBOX_ITEM_METAL_SLIME_ARMOUR = 'メタスラよろい'
export const TBOX_ITEM_METAL_SLIME_HELM = 'メタスラヘルム'
export const TBOX_ITEM_METAL_SLIME_GAUNTLETS = 'メタスラのこて'
export const TBOX_ITEM_METAL_SLIME_SOLLERETS = 'メタスラブーツ'

export const TBOX_RANK_A_PROBABILITIES = [
  { probability: 10, name: TBOX_ITEM_PANDORAS_BOX },
  { probability: 10, name: TBOX_ITEM_ASTRAL_PLUME },
  { probability: 10, name: TBOX_ITEM_ETHEREAL_STONE },
  { probability: 10, name: TBOX_ITEM_3000G },
  { probability: 10, name: TBOX_ITEM_SAGES_ELIXIR },
  { probability: 15, name: TBOX_ITEM_MINI_MEDAL },
  { probability: 10, name: TBOX_ITEM_GLEEBAN_GOLD_PIECE },
  { probability: 10, name: TBOX_ITEM_RECKLESS_NECKLACE },
  { probability: 8, name: TBOX_ITEM_ORICHALCUM },
  { probability: 1, name: TBOX_ITEM_METAL_SLIME_SWORD },
  { probability: 1, name: TBOX_ITEM_METAL_SLIME_SPEAR },
  { probability: 1, name: TBOX_ITEM_METAL_SLIME_SHIELD },
  { probability: 1, name: TBOX_ITEM_METAL_SLIME_ARMOUR },
  { probability: 1, name: TBOX_ITEM_METAL_SLIME_HELM },
  { probability: 1, name: TBOX_ITEM_METAL_SLIME_GAUNTLETS },
  { probability: 1, name: TBOX_ITEM_METAL_SLIME_SOLLERETS }
]

/**
 * ランクS
 */
//export const TBOX_ITEM_PANDORAS_BOX = 'パンドラボックス'
export const TBOX_ITEM_RESET_STONE = 'リサイクルストーン'
//export const TBOX_ITEM_GLEEBAN_GOLD_PIECE = 'グビアナきんか'
//export const TBOX_ITEM_EVAC_U_BELL = 'おもいでのすず'
//export const TBOX_ITEM_SAGES_ELIXIR = 'けんじゃのせいすい'
export const TBOX_ITEM_SAINTED_SOMA = '天使のソーマ'
export const TBOX_ITEM_YGGDRASIL_LEAF = 'せかいじゅのは'
//export const TBOX_ITEM_GOLD_BAR = 'きんかい'
//export const TBOX_ITEM_ORICHALCUM = 'オリハルコン'
export const TBOX_ITEM_STARDUST_SWORD = 'ほしくずのつるぎ'
export const TBOX_ITEM_POKER = 'きしんのまそう'
export const TBOX_ITEM_DEFT_DAGGER = 'サウザンドダガー'
export const TBOX_ITEM_BRIGHT_STAFF = 'ひかりの杖'
export const TBOX_ITEM_GRINGHAM_WHIP = 'グリンガムのムチ'
export const TBOX_ITEM_KNOCKOUT_ROD = 'しゅらのこん'
export const TBOX_ITEM_DRAGONLORD_CLAWS = '竜王のツメ'
export const TBOX_ITEM_CRITICAL_FAN = 'ひっさつのおうぎ'
export const TBOX_ITEM_BAD_AXE = 'グレートアックス'
export const TBOX_ITEM_GROUNDBREAKER = '大地くだき'
export const TBOX_ITEM_METEORANG = 'メテオエッジ'
export const TBOX_ITEM_ANGELS_BOW = '天使の弓'

export const TBOX_RANK_S_PROBABILITIES = [
  { probability: 15, name: TBOX_ITEM_PANDORAS_BOX },
  { probability: 10, name: TBOX_ITEM_RESET_STONE },
  { probability: 10, name: TBOX_ITEM_GLEEBAN_GOLD_PIECE },
  { probability: 10, name: TBOX_ITEM_EVAC_U_BELL },
  { probability: 15, name: TBOX_ITEM_SAGES_ELIXIR },
  { probability: 10, name: TBOX_ITEM_SAINTED_SOMA },
  { probability: 8, name: TBOX_ITEM_YGGDRASIL_LEAF },
  { probability: 5, name: TBOX_ITEM_GOLD_BAR },
  { probability: 5, name: TBOX_ITEM_ORICHALCUM },
  { probability: 1, name: TBOX_ITEM_STARDUST_SWORD },
  { probability: 1, name: TBOX_ITEM_POKER },
  { probability: 1, name: TBOX_ITEM_DEFT_DAGGER },
  { probability: 1, name: TBOX_ITEM_BRIGHT_STAFF },
  { probability: 1, name: TBOX_ITEM_GRINGHAM_WHIP },
  { probability: 1, name: TBOX_ITEM_KNOCKOUT_ROD },
  { probability: 1, name: TBOX_ITEM_DRAGONLORD_CLAWS },
  { probability: 1, name: TBOX_ITEM_CRITICAL_FAN },
  { probability: 1, name: TBOX_ITEM_BAD_AXE },
  { probability: 1, name: TBOX_ITEM_GROUNDBREAKER },
  { probability: 1, name: TBOX_ITEM_METEORANG },
  { probability: 1, name: TBOX_ITEM_ANGELS_BOW }
]

/**
 * 宝箱の中身を全て集約
 */
export const TBOX_CONTENTS_LIST = [
  TBOX_RANK_I_PROBABILITIES,
  TBOX_RANK_H_PROBABILITIES,
  TBOX_RANK_G_PROBABILITIES,
  TBOX_RANK_F_PROBABILITIES,
  TBOX_RANK_E_PROBABILITIES,
  TBOX_RANK_D_PROBABILITIES,
  TBOX_RANK_C_PROBABILITIES,
  TBOX_RANK_B_PROBABILITIES,
  TBOX_RANK_A_PROBABILITIES,
  TBOX_RANK_S_PROBABILITIES
]

/**
 * 敵ランクと宝箱のランクの関係
 */
export const TBOX_RANK_RANGES = [
  { enemyRank: 1, minTreasureBoxRank: 1, maxTreasureBoxRank: 2 },
  { enemyRank: 2, minTreasureBoxRank: 1, maxTreasureBoxRank: 2 },
  { enemyRank: 3, minTreasureBoxRank: 1, maxTreasureBoxRank: 3 },
  { enemyRank: 4, minTreasureBoxRank: 1, maxTreasureBoxRank: 4 },
  { enemyRank: 5, minTreasureBoxRank: 2, maxTreasureBoxRank: 5 },
  { enemyRank: 6, minTreasureBoxRank: 2, maxTreasureBoxRank: 6 },
  { enemyRank: 7, minTreasureBoxRank: 3, maxTreasureBoxRank: 7 },
  { enemyRank: 8, minTreasureBoxRank: 3, maxTreasureBoxRank: 8 },
  { enemyRank: 9, minTreasureBoxRank: 4, maxTreasureBoxRank: 9 },
  { enemyRank: 10, minTreasureBoxRank: 5, maxTreasureBoxRank: 9 },
  { enemyRank: 11, minTreasureBoxRank: 1, maxTreasureBoxRank: 10 },
  { enemyRank: 12, minTreasureBoxRank: 4, maxTreasureBoxRank: 10 }
]
